enum BlockType {
  UNKNOWN = -1,
  HEADER = 1,
  HEADER_WITH_LOGO = 2,
  HEADER_LOGO_MENU = 3,
  HEADER_FREE = 4,
  HEADER_WITH_LOGO_FREE = 5,
  HEADER_LOGO_MENU_FREE = 6,
  TITLE = 10,
  IMAGE = 11,
  TXT_BACKGROUND = 12,
  TXT_BACKGROUND_TALL = 40,
  IMAGE_TEXT = 13,
  MENU_LIST_3 = 14,
  MAP = 15,
  TEXT = 16,
  TEXT_LIST = 17,
  BUTTON = 18,
  HTML = 19,
  CARD_LEFT = 20,
  CARD_RIGHT = 21,
  CARD_LEFT_CENTERED = 22,
  CARD_RIGHT_CENTERED = 23,
  TITLE_TXT_BUTTON = 24,
  TITLE_TXT_BUTTON_TALL = 41,
  BUTTON_LIST = 25,
  CAROUSEL = 26,
  CAROUSEL_TALL = 45,
  CAROUSEL_FIXED = 48,
  CAROUSEL_FIXED_TALL = 49,
  IMAGE_LIST = 27,
  TABLE = 28,
  TABLE_BOTTOM_BORDER = 29,
  TABLE_NO_BORDER = 30,
  CENTERED_IMAGE = 31,
  FULL_BLEED_IMAGE = 32,
  FULL_BLEED_CARD_LEFT_CENTERED = 33,
  FULL_BLEED_CARD_RIGHT_CENTERED = 39,
  LINED_TITLE = 34,
  I_FRAME = 35,
  SNS_OLD = 36,
  SNS = 37,
  ANIMATION_COMPONENT = 38,
  ANIMATION_WITH_DESCRIPTION_COMPONENT = 44,
  CONTACT = 42,
  VIDEO = 43,
  FOOTER = 99,
  BLOCK_MENU_LIST_WITH_COLUMNS = 46,
  BLOCK_MENU_LIST_WITH_EQUAL_SPACE = 47,
  HTML_SAFE = 50,
  I_FRAME_SAFE = 51,
  BLOCK_MENU_LIST_FIXED_MAX_2 = 52,
  BLOCK_MENU_LIST_FIXED_MAX_3 = 53,
  BLOCK_MENU_LIST_FIXED_MOBILE_2 = 54,
  BLOCK_MENU_LIST_EQUAL_MOBILE_2 = 55,
  I_FRAME_SERVICES = 56,
  BLOCK_MENU_LIST_EQUAL_MAX_2 = 57,
  BLOCK_MENU_LIST_EQUAL_MAX_3 = 58,
  FOOTER_FREE = 98,
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockType {
  export function describe(blockType: BlockType): string {
    switch (blockType) {
      case BlockType.HEADER: return 'Header';
      case BlockType.HEADER_WITH_LOGO: return 'Header + Logo';
      case BlockType.HEADER_LOGO_MENU: return 'Logo + Menu';
      case BlockType.HEADER_FREE: return 'Menu';
      case BlockType.HEADER_WITH_LOGO_FREE: return 'Menu + Logo';
      case BlockType.HEADER_LOGO_MENU_FREE: return 'Logo + Menu Set';
      case BlockType.TITLE: return 'Title';
      case BlockType.IMAGE: return 'Image';
      case BlockType.TXT_BACKGROUND: return 'Text + Background Image';
      case BlockType.TXT_BACKGROUND_TALL: return 'Text + Background Image (Tall)';
      case BlockType.IMAGE_TEXT: return 'Image + Text';
      case BlockType.MENU_LIST_3: return 'Menu List x Columns';
      case BlockType.MAP: return 'Map';
      case BlockType.TEXT: return 'Text';
      case BlockType.TEXT_LIST: return 'Text x Columns';
      case BlockType.BUTTON: return 'Button';
      case BlockType.HTML: return '(Old) HTML';
      case BlockType.CARD_LEFT: return 'Title + Text + Left Image';
      case BlockType.CARD_RIGHT: return 'Title + Text + Right Image';
      case BlockType.CARD_LEFT_CENTERED: return 'Text + Left Image';
      case BlockType.CARD_RIGHT_CENTERED: return 'Text + Right Image';
      case BlockType.TITLE_TXT_BUTTON: return 'Title + Text + Button';
      case BlockType.TITLE_TXT_BUTTON_TALL: return 'Title + Text + Button (Tall)';
      case BlockType.BUTTON_LIST: return 'Button Set';
      case BlockType.CAROUSEL: return 'Slider';
      case BlockType.CAROUSEL_TALL: return 'Slider (Tall)';
      case BlockType.CAROUSEL_FIXED: return 'Slider (Fixed Ratio)';
      case BlockType.CAROUSEL_FIXED_TALL: return 'Slider (Fixed Ratio, Tall)';
      case BlockType.IMAGE_LIST: return 'Image Button';
      case BlockType.TABLE: return 'Table';
      case BlockType.TABLE_BOTTOM_BORDER: return 'Table (Bottom Border Only)';
      case BlockType.TABLE_NO_BORDER: return 'Table (No Border)';
      case BlockType.CENTERED_IMAGE: return 'Top Image';
      case BlockType.FULL_BLEED_IMAGE: return 'Image (Full Size)';
      case BlockType.FULL_BLEED_CARD_LEFT_CENTERED: return 'Left Full Image';
      case BlockType.FULL_BLEED_CARD_RIGHT_CENTERED: return 'Right Full Image';
      case BlockType.LINED_TITLE: return 'Double Line (Top and Bottom)';
      case BlockType.I_FRAME: return '(Old) iFrame';
      case BlockType.SNS_OLD: return 'SNS_OLD Block';
      case BlockType.SNS: return 'SNS Block';
      case BlockType.ANIMATION_COMPONENT: return 'Animation Component';
      case BlockType.ANIMATION_WITH_DESCRIPTION_COMPONENT: return 'Animation Component with Description';
      case BlockType.CONTACT: return 'Contact';
      case BlockType.FOOTER: return 'Footer';
      case BlockType.FOOTER_FREE: return 'Menu + Text';
      case BlockType.BLOCK_MENU_LIST_WITH_COLUMNS: return 'Menu List x Columns [Fixed Width]';
      case BlockType.BLOCK_MENU_LIST_WITH_EQUAL_SPACE: return 'Menu List x Columns [Equal Spacing]';
      case BlockType.BLOCK_MENU_LIST_FIXED_MAX_2: return 'Menu List x Columns [Fixed Width, Max 2 Columns] (Mobile 2 Columns)';
      case BlockType.BLOCK_MENU_LIST_FIXED_MAX_3: return 'Menu List x Columns [Fixed Width, Max 3 Columns] (Mobile 2 Columns)';
      case BlockType.BLOCK_MENU_LIST_FIXED_MOBILE_2: return 'Menu List x Columns [Fixed Width] (Mobile 2 Columns)';
      case BlockType.BLOCK_MENU_LIST_EQUAL_MOBILE_2: return 'Menu List x Columns [Equal Spacing] (Mobile 2 Columns)';
      case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_2: return 'Menu List x Columns [Equal Spacing, Max 2 Columns] (Mobile 2 Columns)';
      case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_3: return 'Menu List x Columns [Equal Spacing, Max 3 Columns] (Mobile 2 Columns)';
      case BlockType.VIDEO: return 'Video';
      case BlockType.HTML_SAFE: return 'HTML';
      case BlockType.I_FRAME_SAFE: return 'iFrame';
      case BlockType.I_FRAME_SERVICES: return 'Google Maps / YouTube / Instagram';
      default: return '(Unregistered)';
    }
  }
}

export default BlockType;
